const getters = {
  getArticleCategories: state => locale => state.articleCategories[locale] || [],
  getAllArticleCategories: state => state.articleCategories || [],
  getHomeContent: state => state.homeContent,
  getActiveContent: state => state.activeContent
}

export default getters
